import React, { useState, useEffect } from 'react';
import { 
  Typography,
  FormControl,
  Button,
  Grid,
  TextField,
  Box,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Paper,
 } from "@material-ui/core";
 import { makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import {Alert} from '@material-ui/lab';
import Appbar from './../Appbar';
import axios from 'axios';
import { useSelector } from "react-redux";
// import { analytics } from './../../firebase';
import {
  storeInfo,
  productCategory,
  StoreInfo,
  Message,
  saveStoreToLocalStorage,
  ADD_STORE_URL,
  localStorageKeys
} from './../../constants';
function getStyles(name: string, category: string[], theme: Theme) {
  return {
    fontWeight:
      category.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
  },
  paper: {
    maxWidth: 700,
    margin: 'auto',
    overflow: 'hidden',
  },
  link: {
    textDecoration: "none"
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  back: {
    marginRight: theme.spacing(1),
  },
  align: {
    marginLeft: theme.spacing(2)
  }
}));

const store = storeInfo.slice(0, 4);
const location = storeInfo.slice(4, 8);

const AddStore = () => {
  const classes = useStyles();
  const [category, setcategory] = useState<string[]>([]);
  const [storeDetails, setStoreDetails] = useState<StoreInfo>({
    store_name: "",
    store_owner: "",
    phone_no: "",
    email: "",
    address: "",
    state: "",
    city: "",
    password: "",
  })
  const [disabled, setDisabled] = useState(false);

  const theme = useTheme();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const { auth } = useSelector((state: any) => {
  return state;
});
  const [message, setMessage] = useState<Message>({
    type: undefined,
    msg: '',
  });
  
  
  const clearData = () => {
    setStoreDetails({
      store_name: "",
      store_owner: "",
      phone_no: "",
      email: "",
      address: "",
      state: "",
      city: "",
      password: "",
    })
    setcategory([])
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setDisabled(true)

    const url = ADD_STORE_URL;
    const created_by= auth.token;

    const submitValues = {
      store_name: storeDetails.store_name,
      store_owner: storeDetails.store_owner,
      phone_no: storeDetails.phone_no,
      address: storeDetails.address,
      city: storeDetails.city,
      state: storeDetails.state,
      password: storeDetails.password,
      product_categories: category,
      created_by: created_by
    }
    if (navigator.onLine) {
      axios
        .post(url, submitValues)
        .then((res) => {
          clearData();
          setMessage({
            type: 'success',
            msg: 'Store added successfully',
          });
          // e.target.reset();
          setDisabled(false)
        })
        .catch((err) => {
          console.log(err)
          setMessage({ type: 'error', msg: 'An error occured' });
          setDisabled(false)
        });
      // analytics().logEvent('added-store-online')
    } else {
      saveStoreToLocalStorage(submitValues, localStorageKeys.store);
      clearData();
      setMessage({
        type: 'info',
        msg: "You're currently offline, but don't panic.. your data is safe",
      });
      setDisabled(false)
      // analytics().logEvent('added-store-offline')
    }
  };

  const handleCategoryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setcategory(event.target.value as string[]);
  };

  const onChangeHandler = (e: React.ChangeEvent) => {
    const { name, value } = e.currentTarget as HTMLInputElement;
    setStoreDetails((storeInfo) => ({
      ...storeInfo,
      [name]: value,
    }));
  };

  return (
    <div className={classes.root}>
      <Appbar title="Add Store"/>
      <main className={classes.main}>
      <Grid container>
        <Grid xs={12} sm={2} item/>
        <Grid xs sm={10} item>
        <Paper className={classes.paper}>
          <div className={classes.contentWrapper}>
          {message.msg !== '' && (
            <Alert severity={message.type}>{message.msg}</Alert>
          )}
          <Typography>
            Please fill required fields
          </Typography>
          <form onSubmit={e => handleSubmit(e)}>
            <Grid container spacing={3}>
              {store.map((storeItem, i) => (
                <Grid item sm={6} key={i}>
                  <TextField
                    id={storeItem.name}
                    name={storeItem.name}
                    label={storeItem.label}
                    margin="normal"
                    fullWidth
                    required={storeItem.required}
                    value={storeInfo[storeItem.name as keyof StoreInfo]}
                    type={storeItem.type}
                    onChange={(e) => onChangeHandler(e)}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
              <Box mt={2}>
              <Typography variant="overline">
                Location
              </Typography>
              </Box>
              </Grid>
              {location.map((storeItem, i) => (
                <Grid item key={i} sm={6}>
                  <TextField
                    id={storeItem.name}
                    name={storeItem.name}
                    label={storeItem.label}
                    margin="normal"
                    fullWidth
                    required
                    type="text"
                    value={storeInfo[storeItem.name]}
                    onChange={(e) => onChangeHandler(e)}
                  />
                </Grid>
              ))}
              <Grid item sm={6}>
              <Box mt={2} />
              <FormControl variant="outlined" fullWidth>
              <InputLabel>Store Categories</InputLabel>
              <Select
                label="Store Categories"
                multiple
                input={<Input />}
                MenuProps={MenuProps}
                value={category}
                onChange={handleCategoryChange}>
                {productCategory.map((cate) => (
                  <MenuItem key={cate} value={cate} style={getStyles(cate, category, theme)}>
                    {cate}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              </Grid>
              <Grid item sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  type="submit"
                  disabled={disabled}
                >
                  Add Store
                </Button>
              </Grid>
            </Grid>
          </form>
          </div>
        </Paper>
        </Grid>
      </Grid>
      </main>
    </div>
  );
};

export default AddStore;
